import * as React from 'react';
import { useShowTag } from '../hooks/ad';

type Props = {
    id: string;
    targetId: string;
    className?: string;
    proximity?: number;
};

export function Banner(props: Props) {
    const {
        id,
        targetId,
        className = 'ads__unit ads__unit--banner ads__unit--fullwidth',
        proximity = 100,
    } = props;

    useShowTag(targetId, proximity);

    return (
        <div id={`${targetId}-container`} className={className}>
            <div
                id={targetId}
                className={`inline-container ${id}-inline-container`}
            >
                <span className="ad-info-wrap">
                    <div id={`${targetId}-button`} className="ad-info"></div>
                </span>
            </div>
        </div>
    );
}
